"use strict";

var _regeneratorRuntime = require("/codebuild/output/src400645628/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _classnames = _interopRequireDefault(require("classnames"));

var _commonReact = require("@devsta/common-react");

var _ClipOverlay = _interopRequireDefault(require("./ClipOverlay"));

var _triggerParticleExplosion = _interopRequireDefault(require("../utils/triggerParticleExplosion"));

var _elMeasurements = require("../../../../../constants/elMeasurements");

var _resizerIds = require("../../../constants/resizerIds");

var _utils = require("../../../utils");

var _utils2 = require("../../../../../utils");

require("../styles/_clip.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function getImageUrl(asset, _ref) {
  var isImage = _ref.isImage;

  var _ref2 = asset || {},
      assetFiles = _ref2.assetFiles;

  if (!assetFiles || assetFiles.ORIGINAL && assetFiles.ORIGINAL.status === 'MISSING') {
    return '';
  }

  if (isImage) {
    return assetFiles.ORIGINAL && assetFiles.ORIGINAL.sourceUrl;
  }

  return (0, _utils2.hasTranscodedVideoFiles)({
    assetFiles: assetFiles
  }) && assetFiles.THUMBNAIL ? assetFiles.THUMBNAIL.sourceUrl : 'empty';
}

var Clip = /*#__PURE__*/function (_Component) {
  _inherits(Clip, _Component);

  var _super = _createSuper(Clip);

  function Clip() {
    var _this;

    _classCallCheck(this, Clip);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "handleDeleteClip", (0, _memoizeOne.default)(function (clipId) {
      var onDeleteClip = _this.props.onDeleteClip;
      var onDelete = onDeleteClip(clipId);
      return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var comments, deleteEl, commentIds, bound, centerX, centerY;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                comments = _this.props.comments;
                deleteEl = document.querySelector('.clip-overlay__actions__delete-clip');

                if (deleteEl) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return");

              case 4:
                _context.prev = 4;
                commentIds = comments.filter(function (_ref4) {
                  var commentClipId = _ref4.clipId;
                  return commentClipId === clipId;
                }).map(function (_ref5) {
                  var commentId = _ref5.commentId;
                  return commentId;
                });
                _context.next = 8;
                return _this.deleteComments(commentIds);

              case 8:
                bound = deleteEl.getBoundingClientRect();
                centerX = bound.left + deleteEl.offsetWidth / 2;
                centerY = bound.top + deleteEl.offsetHeight / 2;
                (0, _triggerParticleExplosion.default)(centerX, centerY);
                onDelete();
                _context.next = 17;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](4);

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[4, 15]]);
      }));
    }));

    _defineProperty(_assertThisInitialized(_this), "setHovered", function () {
      var isHovered = _this.state.isHovered;

      if (isHovered) {
        return;
      }

      _this.setState({
        isHovered: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "unsetHovered", function () {
      var isHovered = _this.state.isHovered;

      if (!isHovered) {
        return;
      }

      _this.setState({
        isHovered: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "deleteComments", function (commentIds) {
      var deleteComment = _this.props.deleteComment;
      return Promise.all(commentIds.map(function (commentId) {
        return deleteComment({
          commentId: commentId
        });
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "handleConfirmDeleteComments", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var commentIdsToDelete;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              commentIdsToDelete = _this.state.commentIdsToDelete;
              _context2.prev = 1;
              _context2.next = 4;
              return _this.deleteComments(commentIdsToDelete);

            case 4:
              _this.setState({
                commentIdsToDelete: []
              });

              _context2.next = 9;
              break;

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](1);

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 7]]);
    })));

    _defineProperty(_assertThisInitialized(_this), "handleCancelDeleteComments", function () {
      _this.setState({
        commentIdsToDelete: []
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleClipResize", function (resizeTime, dragTarget) {
      if (resizeTime < 0) {
        return;
      }

      var _this$props = _this.props,
          clip = _this$props.clip,
          _this$props$clip = _this$props.clip,
          startTime = _this$props$clip.startTime,
          duration = _this$props$clip.duration,
          clipId = _this$props$clip.clipId,
          resizeClipInClipsList = _this$props.handleClipResize,
          comments = _this$props.comments;
      var isStartResize = dragTarget.id === _resizerIds.LEFT_RESIZER_ID;

      if ((0, _utils.shouldSkipClipResize)({
        isStartResize: isStartResize,
        clip: clip,
        resizeTime: resizeTime
      })) {
        return;
      }

      var overrideStartTime = _this.state.startTime;
      var newDuration = isStartResize ? startTime + duration - resizeTime : resizeTime - startTime;
      var newStartTime = isStartResize ? resizeTime : overrideStartTime;
      var commentIdsToDelete = comments.filter(function (comment) {
        var clipCommentTime = comment.clipCommentTime,
            commentClipId = comment.clipId; // If there is a clipId in the metadata and it does not match the selected clip, remove the comment.

        if (clipId && commentClipId && commentClipId !== clipId) {
          return false;
        }

        var isValid = !Number.isNaN(Number(clipCommentTime));

        if (!isValid) {
          return false;
        } // check if clipCommentTime is greater than new duration or less than new startTime


        if (clipCommentTime < newStartTime || clipCommentTime > newDuration) {
          return true;
        }

        return false;
      }).map(function (_ref7) {
        var commentId = _ref7.commentId;
        return commentId;
      });

      if (commentIdsToDelete.length) {
        return void _this.setState({
          commentIdsToDelete: commentIdsToDelete
        });
      }

      _this._overridePropsWithState = true;

      _this.setState({
        /* eslint-disable react/no-unused-state */
        duration: newDuration,
        startTime: newStartTime
        /* eslint-enable react/no-unused-state */

      });

      resizeClipInClipsList(clipId, resizeTime, {
        isStartTime: isStartResize
      });
    });

    _this.state = {
      commentIdsToDelete: [],
      isHovered: false,

      /* eslint-disable react/no-unused-state */
      duration: 0,
      startTime: 0
      /* eslint-enable react/no-unused-state */

    };
    return _this;
  }

  _createClass(Clip, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(_ref8) {
      var prevClip = _ref8.clip;
      var _this$props$clip2 = this.props.clip,
          startTime = _this$props$clip2.startTime,
          duration = _this$props$clip2.duration;

      if (startTime !== prevClip.startTime || duration !== prevClip.duration) {
        this._overridePropsWithState = false;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          clip = _this$props2.clip,
          connectDragSource = _this$props2.connectDragSource,
          isDragging = _this$props2.isDragging,
          timelineZoomSeconds = _this$props2.timelineZoomSeconds,
          onSnapClip = _this$props2.onSnapClip,
          onSnapMultipleClips = _this$props2.onSnapMultipleClips,
          asset = _this$props2.asset,
          canUpdateVideo = _this$props2.canUpdateVideo;
      var _this$state = this.state,
          isHovered = _this$state.isHovered,
          commentIdsToDelete = _this$state.commentIdsToDelete;
      var isImage = clip.isImage;

      var _ref9 = this._overridePropsWithState ? this.state : clip,
          duration = _ref9.duration,
          startTime = _ref9.startTime;

      var left = startTime / timelineZoomSeconds * _elMeasurements.TIMELINE_LABEL_WIDTH;

      var template = /*#__PURE__*/_react.default.createElement("div", {
        id: clip.clipId,
        onMouseOver: this.setHovered,
        onMouseLeave: this.unsetHovered,
        className: (0, _classnames.default)('clip', {
          'clip--dragging': isDragging,
          'clip--disabled': !canUpdateVideo,
          'clip--transcoding': !clip.isImage && !(0, _utils2.hasTranscodedVideoFiles)(asset)
        }),
        style: {
          left: left,
          width: "".concat(duration / timelineZoomSeconds * _elMeasurements.TIMELINE_LABEL_WIDTH, "px")
        },
        onFocus: this.setHovered
      }, canUpdateVideo ? /*#__PURE__*/_react.default.createElement(_ClipOverlay.default, {
        clip: clip,
        handleClipResize: this.handleClipResize,
        handleDeleteClip: this.handleDeleteClip(clip.clipId),
        onSnapClip: onSnapClip,
        onSnapMultipleClips: onSnapMultipleClips,
        isHovered: isHovered,
        timelineZoomSeconds: timelineZoomSeconds
      }) : null, /*#__PURE__*/_react.default.createElement(_uiKit.Image, {
        imageUrl: getImageUrl(asset, {
          isImage: isImage
        }),
        height: "100%",
        width: "100%",
        defaultImageIcon: !asset ? 'corrupt' : 'faq',
        defaultIconBackground: "black",
        defaultIconColour: "michael",
        defaultIconSize: 30
      }), /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
        className: "clip__media-icon",
        name: isImage ? 'image' : 'projects',
        size: 15,
        color: "white"
      }), /*#__PURE__*/_react.default.createElement(_commonReact.ConfirmationModal, {
        visible: Boolean(commentIdsToDelete.length),
        onSave: this.handleConfirmDeleteComments,
        onClose: this.handleCancelDeleteComments,
        title: "Are you sure?",
        subtitle: "This will remove comments in clipped footage"
      }));

      return canUpdateVideo ? connectDragSource(template) : template;
    }
  }]);

  return Clip;
}(_react.Component);

var _default = (0, _commonReact.withAssetSelector)(Clip);

exports.default = _default;